import { z } from "zod/v4";
const Nouns = {
    regex: "入力値",
    email: "メールアドレス",
    url: "URL",
    emoji: "絵文字",
    uuid: "UUID",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "日時",
    date: "日付",
    time: "時間",
    duration: "期間",
    ipv4: "IPv4",
    ipv6: "IPv6",
    cidrv4: "IPv4範囲",
    cidrv6: "IPv6範囲",
    base64: "Base64",
    base64url: "Base64URL",
    json_string: "JSON文字列",
    e164: "E.164番号",
    jwt: "JWT",
    ends_with: "ends_with",
    includes: "includes",
    starts_with: "starts_with",
    lowercase: "lowercase",
    uppercase: "uppercase",
};
const types = {
    string: "文字列",
    number: "数値",
    bigint: "Bigint",
    boolean: "真偽値",
    date: "日時",
    int: "整数",
    symbol: "シンボル",
    file: "ファイル",
    array: "配列",
    tuple: "タプル",
    undefined: "undefined",
    null: "NULL",
    object: "object",
    void: "void",
    never: "never",
    any: "any",
    unknown: "unknown",
    record: "record",
    union: "union",
    intersection: "intersection",
    map: "map",
    set: "set",
    enum: "enum",
    literal: "literal",
    nullable: "nullable",
    optional: "optional",
    nonoptional: "nonoptional",
    success: "success",
    transform: "transform",
    default: "default",
    prefault: "prefault",
    catch: "catch",
    nan: "nan",
    pipe: "pipe",
    readonly: "readonly",
    template_literal: "template_literal",
    promise: "promise",
    lazy: "lazy",
    custom: "custom",
};
export const jp = {
    invalid_type: {
        default: ({ expected }) => `${types[expected]}で入力してください。`,
        required: `必須項目です。`,
    },
    invalid_format: {
        startsWith: ({ prefix, }) => `${prefix}で始まる文字列である必要があります。`,
        endsWith: ({ suffix, }) => `${suffix}で終わる文字列である必要があります。`,
        include: ({ includes, }) => `${includes}を含む文字列である必要があります。`,
        regex: ({ pattern, }) => `正規表現${pattern}の形式で入力してください。`,
        default: ({ format }) => `${Nouns[format]}の形式で入力してください。`,
    },
    invalid_value: {
        single: ({ values }) => `${z.core.util.stringifyPrimitive(values.at(0))}を入力してください。`,
        multiple: ({ values }) => `${z.core.util.joinValues(values, "、")}のいずれかを入力してください。`,
    },
    not_multiple_of: ({ divisor, }) => `${divisor}の倍数である必要があります。`,
    unrecognized_keys: ({ keys, }) => `認識されていないキー${keys.length > 1 ? "群" : ""}: ${z.core.util.joinValues(keys, "、")}`,
    invalid_key: ({ origin }) => `${origin}内の無効なキー`,
    invalid_element: ({ origin, key, }) => `${origin}[${key}]内の無効な値: `,
    invalid_union: () => `無効な入力`,
    too_small: {
        collection: {
            inclusive: ({ minimum }) => `${minimum}個以上入力してください。`,
            not_inclusive: ({ minimum, }) => `${minimum}個より多く入力してください。`,
        },
        string: {
            inclusive: ({ minimum }) => `${minimum}文字以上入力してください。`,
            not_inclusive: ({ minimum, }) => `${minimum}文字より長く入力してください。`,
        },
        number: {
            inclusive: ({ minimum }) => `${minimum}以上の値を入力してください。`,
            not_inclusive: ({ minimum, }) => `${minimum}より大きい値を入力してください。`,
        },
        date: {
            inclusive: ({ minimum }) => `${new Date(minimum).toLocaleString()}以降の日時を入力してください。`,
            not_inclusive: ({ minimum, }) => `${new Date(minimum).toLocaleString()}より後の日時を入力してください。`,
        },
        file: {
            inclusive: ({ minimum }) => `${minimum}bytes以上のファイルを入力してください。`,
            not_inclusive: ({ minimum, }) => `${minimum}bytesより大きいファイルを入力してください。`,
        },
    },
    too_big: {
        collection: {
            inclusive: ({ maximum }) => `${maximum}個以下で入力してください。`,
            not_inclusive: ({ maximum, }) => `${maximum}個より少なく入力してください。`,
        },
        string: {
            inclusive: ({ maximum }) => `${maximum}文字以下で入力してください。`,
            not_inclusive: ({ maximum, }) => `${maximum}文字より短く入力してください。`,
        },
        number: {
            inclusive: ({ maximum }) => `${maximum}以下の値を入力してください。`,
            not_inclusive: ({ maximum, }) => `${maximum}より小さい値を入力してください。`,
        },
        date: {
            inclusive: ({ maximum }) => `${new Date(maximum).toLocaleString()}以前の日時を入力してください。`,
            not_inclusive: ({ maximum, }) => `${new Date(maximum).toLocaleString()}より前の日時を入力してください。`,
        },
        file: {
            inclusive: ({ maximum }) => `${maximum}bytes以下のファイルを入力してください。`,
            not_inclusive: ({ maximum, }) => `${maximum}bytesより小さいファイルを入力してください。`,
        },
    },
};
//# sourceMappingURL=error-messages.js.map